/**
 * RESPONSIBILITY: the templates a band down a ministry's page may be built from.
 *
 * THESE STRINGS ARE STORED. A saved band says which template it is by this text, so
 * renaming one silently blanks every band using it. Add freely; rename never.
 *
 * `Alternating` is what every band was before there was a choice: a picture and its words,
 * the side swapping with the band's position. It is the DEFAULT and it is what a band
 * saved before this field existed means - so no ministry page changed the day templates
 * arrived, and nothing had to be converted. The rest are the same set an event's page and
 * the Austin Desi Christmas page offer, so an editor learns one list.
 */
export const BAND_THEME = {
  Alternating: 'Image and text, alternating',
  Text: 'Text',
  Image: 'Image',
  ImageLeft: 'Image left, text right',
  ImageRight: 'Text left, image right',
  ImageTop: 'Image on top, text below',
  TextTop: 'Text on top, image below',
  Faq: 'Questions and answers',
  Video: 'Video',
  Gallery: 'Gallery',
} as const;

export const BAND_THEMES = Object.values(BAND_THEME);

/** What a band with no template stored is. See the note above. */
export const DEFAULT_BAND_THEME = BAND_THEME.Alternating;
